import Error from "components/error"
import { ERROR } from "helpers/data-statuses"
import PropTypes from "prop-types"
import { useContext } from "react"
import { useModelBetaFields } from "resources/beta"
import { useModelId } from "connected-components/dashboard/hooks/use-model-id"
import { usePositionSetBetaInstrument } from "../../helpers"
import { combineTanStackStatuses } from "helpers/data-statuses"
import AssetViewBetaComponent from "./component"

export default function AssetViewBeta({ context, instrumentsWithMetadata, ...props }) {
  const { endDate } = useContext(context)
  const modelId = useModelId()

  const [modelBetaFields, modelBetaFieldsStatus] = useModelBetaFields(modelId)
  const betaInstrument = usePositionSetBetaInstrument(instrumentsWithMetadata.original, { id: modelId, date: endDate })

  const status = combineTanStackStatuses([modelBetaFieldsStatus])

  if (status === ERROR) {
    return <Error />
  }

  return <AssetViewBetaComponent context={context} currentDate={endDate} betaInstrument={betaInstrument} betaFields={modelBetaFields} instrumentsWithMetadata={instrumentsWithMetadata} {...props} />
}

AssetViewBeta.propTypes = {
  modelMetadata: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
  instrumentsWithMetadata: PropTypes.object.isRequired,
}
